import { useAuthStore } from '@/modules/authentication/stores/auth'

export const GatewayApiFetchProxy = {
  fetch: async (input: RequestInfo, init: RequestInit) => {
    const { accessToken } = useAuthStore()

    init.headers = {
      ...init.headers,
      Authorization: `Bearer ${accessToken}`
    }

    return fetch(input, init)
  }
}

export const TenantApiFetchProxy = {
  fetch: async (input: RequestInfo, init: RequestInit) => {
    const { accessToken } = useAuthStore()

    init.headers = {
      ...init.headers,
      Authorization: `Bearer ${accessToken}`
    }

    return fetch(input, init)
  }
}
